import { axios as $http, setHeader } from 'cm'
import './style.scss'
import { getRunTime, debounce } from '../../../public-resource/libs/utils/index'
import Bridge from '../../../public-resource/libs/Bridge/Bridge'
import qs from 'qs'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
const IS_APP = window.$platform.isYixinliApp
// 埋点
window.yxl.stat.init({
  bridge: new Bridge()
})

window.yxl.stat.send({
  name: '问答-精选问答「详情页」访问'
})

// 微信分享
if (window.$platform.isWechat) {
  let currentUrl = document.location.href
  let getWxConfig = `${HOST}/wx/get-wx-package.json`
  $http
    .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
    .then(res => {
      if (res.data.code == 0) {
        var wxConfig = res.data.data
        function loadScript(url, callback) {
          var script = document.createElement('script')
          script.type = 'text/javascript'
          if (typeof callback !== 'undefined') {
            if (script.readyState) {
              script.onreadystatechange = function() {
                if (
                  script.readyState == 'loaded' ||
                  script.readyState == 'complete'
                ) {
                  script.onreadystatechange = null
                  callback()
                }
              }
            } else {
              script.onload = function() {
                callback()
              }
            }
          }
          script.src = url
          document.body.appendChild(script)
        }

        setTimeout(() => {
          loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
            var _config = {
              debug: wxConfig.debug,
              appId: wxConfig.appId,
              timestamp: wxConfig.timestamp,
              nonceStr: wxConfig.nonceStr,
              signature: wxConfig.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            }

            // 微信基本配置信息
            wx.config(_config)

            wx.ready(function() {
              var shareConfig = {
                title: window.wx_share_config.title,
                desc: window.wx_share_config.desc,
                link: window.location.href,
                imgUrl: window.wx_share_config.cover, // 图片地址
                success: function(res) {},
                cancel: function(res) {},
                fail: function(res) {}
              }
              // 分享到朋友圈
              wx.onMenuShareTimeline(shareConfig)
              // 分享给朋友
              wx.onMenuShareAppMessage(shareConfig)
              // 分享到QQ
              wx.onMenuShareQQ(shareConfig)
              // 分享到腾讯微博
              wx.onMenuShareWeibo(shareConfig)
              // 分享到QQ空间
              wx.onMenuShareQZone(shareConfig)
              wx.updateAppMessageShareData(shareConfig)
              wx.updateTimelineShareData(shareConfig)
            })
          })
        }, 500)
      }
    })
}



// WEBPACK FOOTER //
// ./src/pages/promotion/selectedQa/index.js